import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import NavContainer from './NavContainer';
import Slider from 'rc-slider';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeUp, faTimes } from '@fortawesome/free-solid-svg-icons'
import styles from './ClozeReader.css';


class ClozeReader extends Component {
  constructor(props) {
    super(props);

    this.audioContext = null;
    this.state = {
      current: -1,
      image: null,
      finished: false,
      pages: [],
      selectedRow: null,
      selectedBegin: null,
      selectedEnd: null,
      pressed: false,
      selectedWord: null,
      selectedChunk: null,
      wordStacks: [],
    };
  }

  componentDidMount() {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();
  }

  start() {
    const state = this.copyState();
    const { index, pageId, pages, pageIndex } = this.nextPage();
    state.current = index;
    state.image = pages[pageIndex].image ? pages[pageIndex].pageId : null;
    state.pages = pages;
    state.currentPage = pageIndex;
    state.selectedRow = null;
    state.selectedBegin = null;
    state.selectedEnd = null;
    state.finished = false;
    state.wordStacks = [];
    this.setState(state);
    if (this.props.onStart) {
      this.props.onStart();
    }
  }

  copyState() {
    const state = Object.assign({}, this.state);
    state.wordStacks = state.wordStacks.map(w => Object.assign({}, w));
    return state;
  }

  getRects(rects) {
    const rectPattern = /^(\-?[0-9]+),(\-?[0-9]+),(\-?[0-9]+),(\-?[0-9]+)(\#.+)?/;
    const rectMatch = rects.match(rectPattern);
    const baseRect = [[1, 2, 3, 4].map(i => parseInt(rectMatch[i]))];
    if (!rectMatch[5]) {
      return baseRect;
    }
    return baseRect.concat(this.getRects(rectMatch[5].substring(1)))
  }

  getPageId(row, rowIndex) {
    const imagePattern = /^\!([^\#]+)\#(.+)$/;
    const imageMatch = row[0].match(imagePattern);
    if (imageMatch) {
      return {
        pageId: imageMatch[1],
        image: true,
        pageDefined: true,
        area: this.getRects(imageMatch[2]),
      };
    }
    const pagePattern = /^\!([0-9]+)\#$/;
    const pageMatch = row[0].match(pagePattern);
    if (pageMatch) {
      return {
        pageId: pageMatch[1],
        image: false,
        pageDefined: true,
        area: null,
      };
    }
    return {
      pageId: `!R${rowIndex}`,
      image: false,
      pageDefined: false,
      area: null,
    };
  }

  nextPage(nextIndex) {
    const rectPattern = /^\!\#(.+)$/;
    const pages = [];
    let bounds = null;
    this.props.data.rows.forEach((row, rowIndex) => {
      const { pageId, image, pageDefined, area } = this.getPageId(row, rowIndex);
      if (pages.length == 0 || pages[pages.length - 1].pageId != pageId) {
        bounds = [];
        pages.push({ pageId, image, rowIndex, bounds });
      }
      let lastbound = { area, row, rowIndex, beginIndex: pageDefined ? 1 : 0, endIndex: row.length };
      bounds.push(lastbound);
      if (image) {
        row.slice(1).forEach((cell, i) => {
          const rectMatch = cell.match(rectPattern);
          if (!rectMatch) {
            return;
          }
          lastbound.endIndex = i + 1;
          const area = this.getRects(rectMatch[1]);
          lastbound = { area, row, rowIndex, beginIndex: i + 2, endIndex: row.length };
          bounds.push(lastbound);
        });
      } else {
        row.forEach((cell, i) => {
          if (cell.trim() != '.') {
            return;
          }
          lastbound.endIndex = i + 1;
          lastbound = { area: null, row, rowIndex, beginIndex: i + 1, endIndex: row.length };
          bounds.push(lastbound);
        });
      }
    });
    let index = nextIndex === undefined ? this.state.current + 1 : nextIndex;
    if (this.props.data.rows.length <= index) {
      const { pageId } = this.getPageId(
        this.props.data.rows[this.props.data.rows.length - 1],
        this.props.data.rows.length - 1
      );
      return {
        index: this.props.data.rows.length,
        pageId,
        pageIndex: pages.length - 1,
        pages,
      };
    }
    const { pageId } = this.getPageId(this.props.data.rows[index], index);
    const rowIndices = this.props.data.rows
      .map((row, i) => [row, i])
      .filter(rowd => this.getPageId(rowd[0][0], rowd[0][1]).pageId == pageId)
      .map(rowd => rowd[1]);
    return {
      index: rowIndices[rowIndices.length - 1],
      pageId,
      pageIndex: pages
        .map((p, index) => [p, index])
        .filter(pd => pd[0].pageId == pageId)
        .map(pd => pd[1])[0],
      pages,
    };
  }

  pageChange(pindex) {
    console.log('Page', pindex);
    const state = this.copyState();
    const { index, pageId, pages, pageIndex } = this.nextPage(this.state.pages[pindex].rowIndex);
    state.current = index;
    state.image = pages[pageIndex].image ? pages[pageIndex].pageId : null;
    state.pages = pages;
    state.currentPage = pageIndex;
    state.selectedRow = null;
    state.selectedBegin = null;
    state.selectedEnd = null;
    state.wordStacks = [];
    this.setState(state);
    if (this.props.onPageChange) {
      this.props.onPageChange(pageIndex);
    }
  }

  drawDisplay() {
    const canvas = this.refs.display;
    const image = this.refs.image;
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0);

    if (!this.state.pages || !this.state.pages[this.state.currentPage]) {
      return;
    }
    if (this.state.pressed) {
      this.state.pages[this.state.currentPage].bounds.forEach(bound => {
        if (bound.rowIndex == this.state.selectedRow && bound.beginIndex == this.state.selectedBegin) {
          return;
        }
        bound.area.forEach(area => {
          const x = area[0];
          const y = area[1];
          const width = area[2];
          const height = area[3];
          ctx.fillStyle = 'rgba(200, 200, 0, 0.5)';
          ctx.fillRect(x, y, width, height);
        });
      });
    }
    this.state.pages[this.state.currentPage].bounds.forEach(bound => {
      if (bound.rowIndex != this.state.selectedRow || bound.beginIndex != this.state.selectedBegin) {
        return;
      }
      bound.area.forEach(area => {
        const x = area[0];
        const y = area[1];
        const width = area[2];
        const height = area[3];
        ctx.fillStyle = 'rgba(200, 0, 0, 0.5)';
        ctx.fillRect(x, y, width, height);
      });
    });
  }

  imageLoad() {
    console.log('Loaded');
    this.drawDisplay();
  }

  getMousePointer(ev) {
    const rate = this.refs.display.offsetWidth / this.refs.display.width;
    return {
      x: ev.nativeEvent.offsetX / rate,
      y: ev.nativeEvent.offsetY / rate,
    };
  }

  showStatement(rowIndex, beginIndex, callback) {
    if (!this.state.pages || !this.state.pages[this.state.currentPage]) {
      return;
    }
    const target = this.state.pages[this.state.currentPage].bounds
      .filter(b => b.rowIndex == rowIndex && b.beginIndex == beginIndex);
    const state = this.copyState();
    if (target.length > 0) {
      state.selectedRow = target[0].rowIndex;
      state.selectedBegin = target[0].beginIndex;
      state.selectedEnd = target[0].endIndex;
    } else {
      state.selectedRow = null;
      state.selectedBegin = null;
      state.selectedEnd = null;
    }
    state.selectedWord = null;
    state.selectedChunk = null;
    state.wordStacks = [];
    this.setState(state, callback);
    if (state.selectedRow !== null && this.props.onStatementOpen) {
      this.props.onStatementOpen(this.props.data
        .rows[state.selectedRow].slice(
          state.selectedBegin, state.selectedEnd
        ))
    }
  }

  areaContains(areas, p) {
    return areas
      .some(area => area[0] <= p.x && p.x < area[0] + area[2] &&
        area[1] <= p.y && p.y < area[1] + area[3]);
  }

  mouseDown(ev) {
    if (!this.state.pages || !this.state.pages[this.state.currentPage]) {
      return;
    }
    const p = this.getMousePointer(ev);
    const target = this.state.pages[this.state.currentPage].bounds
      .filter(b => this.areaContains(b.area, p));
    console.log('Down', p, target, this.state.pages[this.state.currentPage]);
    this.showStatement(
      target.length > 0 ? target[0].rowIndex : null,
      target.length > 0 ? target[0].beginIndex : null,
      () => {
        const newState = this.copyState();
        newState.pressed = true;
        this.setState(newState, () => {
          this.drawDisplay();
        });
      }
    );
  }

  mouseUp(ev) {
    const state = this.copyState();
    state.pressed = false;
    this.setState(state, () => {
      this.drawDisplay();
    });
  }

  parseText(def) {
    const lexpattern = /^([^a-zA-Z]*)([a-zA-Z]+)(.*)/;
    let remain = def;
    const tokens = [];
    while (remain.length > 0) {
      const m = remain.match(lexpattern);
      if (!m) {
        tokens.push(remain);
        break;
      }
      if (m[1].length > 0) {
        tokens.push(m[1]);
      }
      tokens.push(m[2]);
      remain = m[3];
    }
    return tokens;
  }

  resolveTranslateRequest(words) {
    if (this.props.translateRequest) {
      return this.props.translateRequest(axios, words);
    }
    return axios.post(`${this.props.baseURL || ''}/translate/${this.props.context}`, {
      words: words.join(' ')
    });
  }

  async translateWords(words) {
    const resp = await this.resolveTranslateRequest(words);
    console.log('Post', resp);
    if (resp.status != 200) {
      throw new Error(`Invalid status code: ${resp.status}`);
    }
    return resp.data;
  }

  resolveWordRequest(word) {
    if (this.props.wordRequest) {
      return this.props.wordRequest(axios, word.toLowerCase());
    }
    return axios.get(`${this.props.baseURL || ''}/word/${this.props.context}/${word.toLowerCase()}`);
  }

  resolveImageURL(image) {
    if (this.props.imageURL) {
      return this.props.imageURL(image);
    }
    return `${this.props.baseURL || ''}/image/${this.props.context}/${image}`;
  }

  async loadWord(word) {
    const resp = await this.resolveWordRequest(word);
    console.log('Get', resp);
    if (resp.status != 200) {
      throw new Error(`Invalid status code: ${resp.status}`);
    }
    if (resp.data.results.length == 0) {
      return { word, meanings: [], pronunciation: null };
    }
    const meanings = [];
    let pronunciation = null;
    resp.data.results.forEach(result => {
      result.lexicalEntries.forEach(lexicalEntry => {
        const pronunciations = (lexicalEntry.pronunciations || []).filter(p => p.audioFile);
        if (pronunciations.length > 0) {
          pronunciation = {
            phoneticSpelling: pronunciations[0].phoneticSpelling,
            audioFile: pronunciations[0].audioFile,
          };
        }
        lexicalEntry.entries.forEach(entry => {
          entry.senses.forEach(sense => {
            (sense.definitions || []).forEach(def => {
              meanings.push({
                lexicalCategory: (lexicalEntry.lexicalCategory && lexicalEntry.lexicalCategory.text) || 'unknown',
                text: this.parseText(def)
              });
            });
          });
        });
      });
    });
    return { meanings, pronunciation };
  }

  wordClick(depth, word, index, meaningIndex) {
    console.log('Word', word);
    const state = this.copyState();
    const wordStack = {
      depth,
      word,
      words: null,
      enMeanings: null,
      jpTranslates: null,
      enDictRequested: false,
      jpTranslateRequested: false,
      enError: null,
      jpError: null,
    };
    state.wordStacks = state.wordStacks.slice(0, depth).concat([wordStack]);
    if (depth == 0) {
      const wordChunks = ((this.props.data.chunks || [])[state.selectedRow] || [])[state.selectedBegin + index] || [];
      state.selectedWord = index;
      if (!state.selectedChunk || state.selectedChunk.word != state.selectedBegin + index || state.selectedChunk.candidate + 1 >= wordChunks.length) {
        state.selectedChunk = {
          word: state.selectedBegin + index,
          candidate: -1,
          words: [state.selectedBegin + index],
        };
      } else {
        wordStack.words = wordChunks[state.selectedChunk.candidate + 1]
          .map(i => this.props.data.rows[state.selectedRow][i].split('|')[0]);
        state.selectedChunk = {
          word: state.selectedBegin + index,
          candidate: state.selectedChunk.candidate + 1,
          words: wordChunks[state.selectedChunk.candidate + 1],
        };
      }
      console.log('Chunks', wordChunks, state.selectedChunk);
    } else {
      state.wordStacks[depth - 1].enMeanings.forEach((meaning, mindex) => {
        meaning.selectedWord = mindex == meaningIndex ? index : null;
      })
    }
    this.setState(state);
    if (depth == 0 && this.props.onWordsOpen) {
      this.props.onWordsOpen(wordStack.words || [wordStack.word])
    }
  }

  chunkContains(index) {
    if (!this.state.selectedChunk) {
      return false;
    }
    return (this.state.selectedChunk.words || []).includes(this.state.selectedBegin + index);
  }

  volumeClick(pronunciation) {
    this.play(pronunciation.audioFile);
  }

  async play(url) {
    const source = this.audioContext.createBufferSource();
    source.buffer = await this.loadInternal(url);
    source.connect(this.audioContext.destination);
    source.start(0);
  }

  loadInternal(url) {
    const self = this;
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';

      request.onload = () => {
        self.audioContext.decodeAudioData(request.response, buffer => {
          resolve(buffer);
        }, error => {
          resolve(null);
          console.warn('Cannot load', url);
        });
      }
      request.send();
    });
  }

  requestEnDict(wordStack) {
    const state = this.copyState();
    if (!state.wordStacks[wordStack.depth]) {
      return;
    }
    state.wordStacks[wordStack.depth].enDictRequested = true;
    this.setState(state);
    if (this.props.onEnDictRequest) {
      this.props.onEnDictRequest(wordStack.word)
    }
    this.loadWord(wordStack.word)
      .then(loadedWordStack => {
        const state = this.copyState();
        if (!state.wordStacks[wordStack.depth] ||
          (state.wordStacks[wordStack.depth].word != wordStack.word &&
          state.wordStacks[wordStack.depth].words != wordStack.words)) {
          return;
        }
        console.log('Meaning', wordStack.word, loadedWordStack);
        state.wordStacks[wordStack.depth].pronunciation = loadedWordStack.pronunciation;
        state.wordStacks[wordStack.depth].enMeanings = loadedWordStack.meanings;
        this.setState(state);
      })
      .catch(error => {
        console.error('Dictionary error', error);
        const state = this.copyState();
        if (!state.wordStacks[wordStack.depth] ||
          (state.wordStacks[wordStack.depth].word != wordStack.word &&
          state.wordStacks[wordStack.depth].words != wordStack.words)) {
          return;
        }
        state.wordStacks[wordStack.depth].enError = error.toString();
        this.setState(state);
      });
  }

  requestJpTranslate(wordStack) {
    const state = this.copyState();
    if (!state.wordStacks[wordStack.depth]) {
      return;
    }
    state.wordStacks[wordStack.depth].jpTranslateRequested = true;
    this.setState(state);
    if (this.props.onJpTranslateRequest) {
      this.props.onJpTranslateRequest(wordStack.words || [wordStack.word])
    }
    this.translateWords(wordStack.words || [wordStack.word])
      .then(loadedWordStack => {
        const state = this.copyState();
        if (!state.wordStacks[wordStack.depth] ||
          (state.wordStacks[wordStack.depth].word != wordStack.word &&
          state.wordStacks[wordStack.depth].words != wordStack.words)) {
          return;
        }
        console.log('Meaning', wordStack.word, loadedWordStack);
        state.wordStacks[wordStack.depth].jpTranslates = loadedWordStack.meanings;
        this.setState(state);
      })
      .catch(error => {
        console.error('Dictionary error', error);
        const state = this.copyState();
        if (!state.wordStacks[wordStack.depth] ||
          (state.wordStacks[wordStack.depth].word != wordStack.word &&
          state.wordStacks[wordStack.depth].words != wordStack.words)) {
          return;
        }
        state.wordStacks[wordStack.depth].jpError = error.toString();
        this.setState(state);
      });
  }

  renderEnDict(wordStack, stackIndex) {
    if (!wordStack.enDictRequested) {
      return wordStack.words === null && <div className={styles.enDict}><Button
        data-test-reader-en-dict
        onClick={e => this.requestEnDict(wordStack)}
        variant='info'
        size='sm'>
        Oxford English Dictionary
      </Button></div>
    }
    return wordStack.enMeanings !== null ? <div className={styles.DictMean}>
      {wordStack.enMeanings.length == 0 ?
        <span className={styles.NoData}>Not found</span> :
        (wordStack.enMeanings.map((meaning, meaningIndex) =>
          <div key={meaningIndex}>
          {meaning.lexicalCategory && <span className={styles.LexicalCategory}>{meaning.lexicalCategory}</span>}
          {meaning.text.length == 0 ?
            <span className={styles.NoData}>Not found</span> :
            (meaning.text.map((t, index) => t.match(/^[a-zA-Z]+$/) ?
              <span
                key={index}
                className={meaning.selectedWord == index ? `${styles.Word} ${styles.WordSelected}` : styles.Word}
                onClick={ev => this.wordClick(this.state.wordStacks.length - stackIndex, t, index, meaningIndex)}>{t}</span> : t))}
          </div>))}
        </div> : (wordStack.enError ? <div className={styles.DictError}>{wordStack.enError}</div> : <div>Loading...</div>)
  }

  renderJpTranslate(wordStack, stackIndex) {
    if (!wordStack.jpTranslateRequested) {
      return <div className={styles.jpTranslate}><Button
        data-test-reader-jp-translate
        onClick={e => this.requestJpTranslate(wordStack)}
        variant='info'
        size='sm'>
        日本語に翻訳
      </Button></div>
    }
    return wordStack.jpTranslates !== null ? <div className={styles.DictMean}>
      {wordStack.jpTranslates.length == 0 ?
        <span className={styles.NoData}>Not found</span> :
        (wordStack.jpTranslates.map((meaning, meaningIndex) =>
          <div key={meaningIndex}>
          {meaning.text.length == 0 ?
            <span className={styles.NoData}>Not found</span> :
            (meaning.text.map((t, index) => t.match(/^[a-zA-Z]+$/) ?
              <span
                key={index}
                className={meaning.selectedWord == index ? `${styles.Word} ${styles.WordSelected}` : styles.Word}
                onClick={ev => this.wordClick(this.state.wordStacks.length - stackIndex, t, index, meaningIndex)}>{t}</span> : t))}
          </div>))}
        </div> : (wordStack.jpError ? <div className={styles.DictError}>{wordStack.jpError}</div> : <div>Loading...</div>)
  }

  closeStack(depth) {
    const state = this.copyState();
    state.wordStacks = state.wordStacks.slice(0, depth);
    if (depth > 0) {
      (state.wordStacks[depth - 1].enMeanings || []).forEach(meaning => {
        meaning.selectedWord = null;
      });
    } else {
      state.selectedWord = null;
      state.selectedChunk = null;
    }
    this.setState(state);
  }

  closeSentence() {
    const state = this.copyState();
    state.selectedRow = null;
    state.selectedBegin = null;
    state.selectedEnd = null;
    state.selectedWord = null;
    state.selectedChunk = null;
    state.wordStacks = [];
    this.setState(state);
  }

  finish() {
    if (this.props.onFinish) {
      this.props.onFinish();
    }
  }

  joinWords(words) {
    let r = '';
    words.forEach((word, index) => {
      if (r.length > 0 && word.match(/[a-zA-Z0-9]+/)) {
        r += ' ';
      }
      r += word;
    });
    return r;
  }

  searchByGoogle(words) {
    const word = words.join(' ');
    const url = `https://www.google.com/search?q=${encodeURIComponent(word)}&hl=en`;
    if (!this.props.onGoogleSearch) {
      window.open(url, '_blank');
      return;
    }
    this.props.onGoogleSearch(words, () => {
      window.open(url, '_blank');
    });
  }

  render() {
    const actives = Object.values(this.state.choice || {}).filter(c => c.active);
    const content = (this.state.image == null ? <div className={styles.TextBase}>
        {(this.state.pages[this.state.currentPage] || { bounds: [] }).bounds
          .map((bound, index) => (<span
            key={index}
            className={bound.rowIndex == this.state.selectedRow && bound.beginIndex == this.state.selectedBegin ? styles.TextSelected : ''}
            onClick={e => this.showStatement(bound.rowIndex, bound.beginIndex) }>
            {this.joinWords(bound.row.slice(bound.beginIndex, bound.endIndex).map(w => w.split('|')[0]))}
          </span>))}
      </div> :
      <div className={styles.ImageBase}>
      <canvas
        className={styles.Image}
        ref='display'
        onMouseDown={ev => this.mouseDown(ev)}
        onMouseUp={ev => this.mouseUp(ev)}
        />
      {this.state.image &&
        <img
          ref='image'
          className={styles.CachedImage}
          onLoad={e => this.imageLoad(e)}
          src={this.resolveImageURL(this.state.image)} />}
    </div>);
    return (
      <div className={styles.ImageReader}>
        {this.state.current < 0 ?
          <div className={styles.Greeting}>
            <Button
              data-test-image-reader-start
              disabled={this.props.ready === undefined ? false : !this.props.ready}
              onClick={e => this.start()}
              variant='primary'>
              はじめる
            </Button>
          </div> :
          (this.state.finished ?
            <div className={styles.Finished}>
              終わりです！クイズにチャレンジしてみましょう！
            </div> :
            <div>
              <NavContainer>
                {this.state.wordStacks.map((wordStack_, stackIndex) => {
                  const wordStack = this.state.wordStacks[this.state.wordStacks.length - stackIndex - 1];
                  return <div className={styles.Dict} key={stackIndex}>
                        <span className={styles.DictWord}>
                          {wordStack.words ? wordStack.words.join(' ').toLowerCase() : wordStack.word.toLowerCase()}
                          {wordStack.pronunciation &&
                            <span
                              className={styles.Voice}
                              onClick={ev => this.volumeClick(wordStack.pronunciation)}>
                              <span className={styles.PhoneticSpelling}>{wordStack.pronunciation.phoneticSpelling}</span>
                              <FontAwesomeIcon icon={faVolumeUp} />
                            </span>}
                        </span>
                        <div className={styles.CloseButton}>
                          <span onClick={ev => this.closeStack(this.state.wordStacks.length - stackIndex - 1)}>
                            <FontAwesomeIcon icon={faTimes} />
                          </span>
                        </div>
                        {this.renderEnDict(wordStack, stackIndex)}
                        {this.renderJpTranslate(wordStack, stackIndex)}
                      <div className={styles.GoogleSearch}>
                        <a href='#'
                          onClick={e => this.searchByGoogle(wordStack.words || [wordStack.word])}>
                          Search by Google
                        </a></div>
                    </div>})}
                {this.state.selectedRow !== null && this.props.data.rows[this.state.selectedRow] ?
                  <div className={styles.Sentence}>
                    <div className={styles.DictHelp}>
                      {this.state.wordStacks.length > 0 ? '複数回単語をタップすると句で検索' : '以下で単語をタップすると辞書が開きます'}
                    </div>
                    <div className={styles.CloseButton}>
                      <span onClick={ev => this.closeSentence()}>
                        <FontAwesomeIcon icon={faTimes} />
                      </span>
                    </div>
                    {this.props.data.rows[this.state.selectedRow].slice(this.state.selectedBegin, this.state.selectedEnd).map((row, index) =>
                      <span>
                        {index > 0 && row.split('|')[0].match(/[a-zA-Z0-9]+/) &&
                          <span className={`${styles.WordSpace} ${this.chunkContains(index - 1) && this.chunkContains(index) ? styles.WordSelected : ''}`}> </span>}
                        <span
                          key={index}
                          className={this.state.selectedWord == index || this.chunkContains(index) ? `${styles.Word} ${styles.WordSelected}` : styles.Word}
                          onClick={ev => this.wordClick(0, row.split('|')[0], index)}>{row.split('|')[0]}</span>
                      </span>
                    )}
                  </div> : <div className={styles.SentenceHelp}>
                    文をタップするとここに大きく表示されます
                  </div>}
                <div className={styles.PageSlider}>
                  <Slider
                    min={0}
                    max={this.state.pages.length - 1}
                    defaultValue={this.state.currentPage}
                    onChange={e => this.pageChange(e)}/>
                  <div className={styles.PageNumber}>
                    Page #{this.state.currentPage + 1} / {this.state.pages.length}
                    <Button
                      data-test-image-reader-finish
                      onClick={e => this.finish()}
                      variant='danger'
                      size='sm'>
                      終了する
                    </Button>
                  </div>
                </div>
              </NavContainer>
              {content}
            </div>)}
      </div>
    );
  }
}

export default ClozeReader;
